webpackJsonp([18],{

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_icon_style__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_icon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Common_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Views_components_header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Views_components_foot__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_meta__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_svgaplayerweb__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_svgaplayerweb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_svgaplayerweb__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_meta__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_icon__["a" /* default */]);
var userUrl = __WEBPACK_IMPORTED_MODULE_3_Constans__["a" /* default */].AllUrl.url.dev;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  components: {
    myHeader: __WEBPACK_IMPORTED_MODULE_6_Views_components_header__["a" /* default */],
    myFooter: __WEBPACK_IMPORTED_MODULE_7_Views_components_foot__["a" /* default */]
  },
  data: function data() {
    return {
      hotOnlineList: [],
      canonicalUrl: "",
      title: "",
      desc: "",
      logo: "https://static.lespark.cn/pc_img/images/baihua/logo.svga",
      imgJb: {
        j1: "https://static.lespark.cn/pc_img/images/baihua/j1.png",
        j2: "https://static.lespark.cn/pc_img/images/baihua/j2.png",
        j3: "https://static.lespark.cn/pc_img/images/baihua/j3.png",
        j4: "https://static.lespark.cn/pc_img/images/baihua/j4.png",
        j5: "https://static.lespark.cn/pc_img/images/baihua/j5.png",
        j6: "https://static.lespark.cn/pc_img/images/baihua/j6.png"
      },
      isTq: false,
      isLogo: false,
      isAni: false,
      isTitle: false,
      bg2Tips: [],
      bg3Tips: []
    };
  },

  props: {
    color: {
      type: String,
      default: "#fff"
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      meta: [{
        vmid: "description",
        name: "description",
        content: this.desc
      }],
      link: [{
        ref: "canonical",
        href: this.canonicalUrl
      }]
    };
  },
  created: function created() {
    var that = this;
    var _arg = __WEBPACK_IMPORTED_MODULE_4_Common_util__["a" /* default */].getQueryStringArgs();
    var language = __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("language");
    if (__WEBPACK_IMPORTED_MODULE_4_Common_util__["a" /* default */].getLang() == 'cn' || _arg.lang == "zh-Hans-TW" || language == "简体中文") {
      that.canonicalUrl = "https://www.lespark.cn/help.html?lang=zh-Hant-TW";
      that.title = "LesPark";
      that.desc = "LesPark汇集了众多有趣、有颜、有才的女性主播，您可以实时登陆观看热门直播的精彩视频，LesPark可满足您对于观看高颜值直播、视频交友等多种需求。";
    } else if (__WEBPACK_IMPORTED_MODULE_4_Common_util__["a" /* default */].getLang() == 'en' || _arg.lang == "en" || language == "English") {
      that.canonicalUrl = "https://www.lespark.cn/help.html?lang=en";
      that.title = "LesPark";
      that.desc = "LesPark is a collection of popular topics of interest to lesbians, where you can interact with women from all over the world.";
    } else {
      that.canonicalUrl = "https://www.lespark.cn/help.html";
      that.title = "LesPark";
      that.desc = "LesPark匯集了眾多有趣、有顏、有才的女性主播，您可以實時登陸觀看熱門直播的精彩視頻，LesPark可滿足您對於觀看高顏值直播、視頻交友等多種需求。";
    }
  },
  mounted: function mounted() {
    var that = this;
    this.logoSvga();
    this.tqSvga();
    this.titleSvga();
    that.bg2Tips = that.$t("baiHuaTxt.bg2Tips");
    that.bg3Tips = that.$t("baiHuaTxt.bg3Tips");
    that.isAni = true;
  },

  methods: {
    goRule: function goRule() {
      window.location.href = '/baihuaRule.html';
    },
    logoSvga: function logoSvga() {
      var that = this;
      var mycanvas = document.getElementById("logoBaihua");
      var player = new __WEBPACK_IMPORTED_MODULE_9_svgaplayerweb___default.a.Player("#logoBaihua");
      var parser = new __WEBPACK_IMPORTED_MODULE_9_svgaplayerweb___default.a.Parser("#logoBaihua");
      // this.imageUrl 定义一个参数接收url
      parser.load(this.logo, function (videoItem) {
        player.setVideoItem(videoItem);
        player.startAnimation(setTimeout(function () {
          that.isLogo = true;
        }, 1000));
      });
    },
    tqSvga: function tqSvga() {
      var that = this;
      var mycanvas = document.getElementById('tq');
      var player = new __WEBPACK_IMPORTED_MODULE_9_svgaplayerweb___default.a.Player("#tq");
      var parser = new __WEBPACK_IMPORTED_MODULE_9_svgaplayerweb___default.a.Parser("#tq");
      // this.imageUrl 定义一个参数接收url
      parser.load(this.$t('baiHuaTxt.tqSvga'), function (videoItem) {
        player.setVideoItem(videoItem);
        player.startAnimation(setTimeout(function () {
          that.isTq = true;
        }, 1000));
      });
    },
    titleSvga: function titleSvga() {
      var that = this;
      var mycanvas = document.getElementById('titleSvga');
      var player = new __WEBPACK_IMPORTED_MODULE_9_svgaplayerweb___default.a.Player("#titleSvga");
      var parser = new __WEBPACK_IMPORTED_MODULE_9_svgaplayerweb___default.a.Parser("#titleSvga");
      // this.imageUrl 定义一个参数接收url
      parser.load(this.$t('baiHuaTxt.titleSvga'), function (videoItem) {
        player.setVideoItem(videoItem);
        player.startAnimation(setTimeout(function () {
          that.isTitle = true;
        }, 2000));
      });
    }
  }
});

/***/ }),

/***/ 792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_vue__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bus__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Views_css_reset_css__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Views_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_Views_css_reset_css__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_bus__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
  locale: 'zh', // 语言标识 
  messages: {
    'zh': __webpack_require__(12),
    'zh-f': __webpack_require__(13),
    'en': __webpack_require__(14)
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  i18n: i18n,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__app_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08bb998b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(796);
function injectStyle (ssrContext) {
  __webpack_require__(794)
  __webpack_require__(795)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08bb998b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08bb998b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 794:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 795:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header',{attrs:{"color":"#fff"}}),_vm._v(" "),_c('img',{staticClass:"bg bg1",attrs:{"src":"https://static.lespark.cn/pc_img/images/baihua/bg1.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"bg bg2",attrs:{"src":"https://static.lespark.cn/pc_img/images/baihua/bg2.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"bg bg3",attrs:{"src":"https://static.lespark.cn/pc_img/images/baihua/bg3.png","alt":""}}),_vm._v(" "),_vm._l((_vm.imgJb),function(img,imgClass){return (imgClass!='j5')?_c('img',{staticClass:"jb",class:imgClass,attrs:{"src":img,"alt":""}}):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLogo),expression:"!isLogo"}],staticClass:"logo-baihua",attrs:{"src":"https://static.lespark.cn/pc_img/images/baihua/logo.png","alt":""}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLogo),expression:"isLogo"}],ref:"logoBaihua",staticClass:"logo-baihua",attrs:{"id":"logoBaihua"}}),_vm._v(" "),_c('div',{staticClass:"svgaTitle"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isTitle),expression:"!isTitle"}],attrs:{"id":"titleSvga"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTitle),expression:"isTitle"}],staticClass:"bg1-title",attrs:{"src":_vm.$t('baiHuaTxt.bg1Title'),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"bg1-award",class:{'award-ani':_vm.isAni}},_vm._l((_vm.$t('baiHuaTxt.award')),function(award,awardIndex){return _c('div',[_vm._v(_vm._s(award))])}),0),_vm._v(" "),_c('div',{staticClass:"bg1-tips"},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.bg1Tips")))]),_vm._v(" "),_c('div',{staticClass:"bg1-tips2"},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.bg1Tips2")))]),_vm._v(" "),_c('div',{staticClass:"rule",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.goRule()}}},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.rule"))+" >")]),_vm._v(" "),_c('div',{staticClass:"bg2-title"},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.bg2Title")))]),_vm._v(" "),_c('div',{staticClass:"bg2-tips"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.bg2Tips[0])}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.bg2Tips[1])}}),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"24px"},domProps:{"innerHTML":_vm._s(_vm.bg2Tips[2])}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.bg2Tips[3])}}),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"24px"},domProps:{"innerHTML":_vm._s(_vm.bg2Tips[4])}})]),_vm._v(" "),_c('div',{staticClass:"bg2-img ani2"},[_c('img',{attrs:{"src":_vm.$t('baiHuaTxt.bg2Img'),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"bg2-tips2"},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.bg2Tips2")))]),_vm._v(" "),_c('div',{staticClass:"bg2-tips3"},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.bg2Tips3")))]),_vm._v(" "),_c('div',{staticClass:"bg3-title"},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.bg3Title")))]),_vm._v(" "),_c('div',{staticClass:"bg3-tips"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.bg3Tips[0])}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.bg3Tips[1])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.bg3Tips[2])}})]),_vm._v(" "),_c('div',{staticClass:"bg3-img"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isTq),expression:"!isTq"}],attrs:{"src":_vm.$t('baiHuaTxt.bg3Img'),"alt":""}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTq),expression:"isTq"}],attrs:{"id":"tq"}})]),_vm._v(" "),_c('div',{staticClass:"bg3-tips2"},[_vm._v("\n        "+_vm._s(_vm.$t("baiHuaTxt.bg3Tips2"))+"\n        "),_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.goRule()}}},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.rule"))+" >")])]),_vm._v(" "),_c('div',{staticClass:"bg3-tips2"},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.bg3Tips3")))]),_vm._v(" "),_c('div',{staticClass:"bg3-tips2"},[_vm._v(_vm._s(_vm.$t("baiHuaTxt.bg3Tips4")))])]),_vm._v(" "),_c('my-footer')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[792]);


// WEBPACK FOOTER //
// js/baihua.f0730dfdc02b704fcf7f.js